module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper pt-header65"
  }, [_c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "hedder_wrap"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("戻る")])]), _c('div', {
    staticClass: "hedder_wrap-right"
  }, [_c('button', {
    staticClass: "star",
    on: {
      "click": function($event) {
        _vm.sendFavorite()
      }
    }
  }, [_c('img', {
    staticClass: "star__icon",
    attrs: {
      "src": _vm.getFavoriteImageByState(_vm.isFavorited),
      "alt": "お気に入り"
    }
  })]), _c('button', {
    staticClass: "hamburger",
    on: {
      "click": function($event) {
        _vm.toggleHamburger()
      }
    }
  }, [_c('img', {
    staticClass: "hamburger__icon",
    attrs: {
      "src": require("../images/icon_hamburger_vertical.png"),
      "alt": "メニュー"
    }
  })]), (_vm.isHamburgerListShow) ? _c('ul', {
    staticClass: "hamburger-list"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.card.is_facing_type),
      expression: "!card.is_facing_type"
    }]
  }, [_c('button', {
    staticClass: "hamburger-list__item -underline",
    on: {
      "click": function($event) {
        _vm.downloadCardById()
      }
    }
  }, [_c('img', {
    staticClass: "hamburger-list__item--image",
    attrs: {
      "src": require("../images/icon_download_blue.png"),
      "alt": "ダウンロード"
    }
  }), _c('p', {
    staticClass: "hamburger-list__item--name"
  }, [_vm._v("画像としてダウンロード")])])]), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.card.is_delete_possible || _vm.authorityCheck()),
      expression: "card.is_delete_possible || authorityCheck()"
    }]
  }, [_c('button', {
    staticClass: "hamburger-list__item -underline",
    on: {
      "click": function($event) {
        _vm.showDeleteCardModal()
      }
    }
  }, [_c('img', {
    staticClass: "hamburger-list__item--image",
    attrs: {
      "src": require("../images/icon_trash_blue.png"),
      "alt": "削除"
    }
  }), _c('p', {
    staticClass: "hamburger-list__item--name"
  }, [_vm._v("削除")])])]), (!_vm.card.is_problem_reported) ? _c('li', [_c('button', {
    staticClass: "hamburger-list__item",
    on: {
      "click": function($event) {
        _vm.showReportProblem()
      }
    }
  }, [_c('img', {
    staticClass: "hamburger-list__item--image",
    attrs: {
      "src": require("../images/icon_patolamp_blue.png"),
      "alt": "通報"
    }
  }), _c('p', {
    staticClass: "hamburger-list__item--name"
  }, [_vm._v("問題を報告する")])])]) : _vm._e(), (_vm.card.is_problem_reported) ? _c('li', [_vm._m(0)]) : _vm._e()]) : _vm._e()])])]), (_vm.isGetEsMycard) ? [_c('div', {
    ref: "es_mycard_download",
    staticClass: "es_mycard_download_wrap"
  }, [(!_vm.card.is_facing_type) ? _c('div', {
    staticClass: "es_mycard"
  }, [_c('div', {
    staticClass: "es_mycard_background"
  }, [_c('img', {
    attrs: {
      "src": _vm.getBackgroundImageByImageName(_vm.card.background_path)
    }
  })]), _c('div', {
    staticClass: "get_user_box"
  }, [_c('div', {
    staticClass: "get_user_box_img",
    attrs: {
      "data-html2canvas-ignore": "true"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goProfile(_vm.card.get_user_id)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getUserImage(_vm.card.get_user_image)
    }
  })])]), _c('div', {
    staticClass: "get_user_box_body"
  }, [_c('p', {
    staticClass: "get_user_box_body-role"
  }, [_vm._v(_vm._s(_vm.card.get_user_shop_name))]), _c('p', {
    staticClass: "get_user_box_body-name"
  }, [_vm._v(_vm._s(_vm.card.get_user_name))])])]), _c('div', {
    staticClass: "give_user_box"
  }, [_c('div', {
    staticClass: "give_user_box_img",
    attrs: {
      "data-html2canvas-ignore": "true"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goProfile(_vm.card.give_user_id)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getUserImage(_vm.card.give_user_image)
    }
  })])]), _c('div', {
    staticClass: "give_user_box_body"
  }, [_c('p', {
    staticClass: "give_user_box_body-role"
  }, [_vm._v(_vm._s(_vm.card.give_user_shop_name))]), _c('p', {
    staticClass: "give_user_box_body-name"
  }, [_vm._v(_vm._s(_vm.card.give_user_name))])])]), _c('div', {
    staticClass: "comment_box"
  }, [_c('div', {
    staticClass: "comment_box_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.getCharacter1ImageByImageName(_vm.card.character_1_folder_path, _vm.card.character_1_path)
    }
  })]), _c('div', {
    staticClass: "comment_box_body"
  }, [_c('p', {
    staticClass: "comment_box_body-text font_size",
    class: _vm.setClassCommentFontSize
  }, [_vm._v(_vm._s(_vm.card.comments))])])]), _c('div', {
    staticClass: "created_at"
  }, [_c('p', {
    staticClass: "day"
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.card.created_at)))])]), _c('div', {
    staticClass: "character_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.getCharacter2ImageByImageName(_vm.card.character_2_path)
    }
  })])]) : _vm._e(), (_vm.card.is_facing_type) ? _c('div', {
    staticClass: "es_mycard_facingtype"
  }, [(_vm.card.back_card_path) ? _c('p', {
    staticClass: "title"
  }, [_vm._v("表面")]) : _vm._e(), _c('div', {
    staticClass: "es_mycard_facingtype_front"
  }, [_c('img', {
    attrs: {
      "src": _vm.getFacingtypeImageByImage(_vm.card.front_card_path) + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    }
  })]), (_vm.card.back_card_path) ? _c('div', {
    staticClass: "es_mycard_facingtype_back_wrap"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("裏面")]), _c('div', {
    staticClass: "es_mycard_facingtype_back"
  }, [_c('img', {
    attrs: {
      "src": _vm.getFacingtypeImageByImage(_vm.card.back_card_path) + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    }
  })])]) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "philosophy"
  }, [_c('div', {
    staticClass: "philosophy_list"
  }, [_c('ul', [(_vm.card.idea_peace_ming) ? _c('li', [_vm._v("安心")]) : _vm._e(), (_vm.card.idea_sincere) ? _c('li', [_vm._v("誠実")]) : _vm._e(), (_vm.card.idea_excitement) ? _c('li', [_vm._v("感動")]) : _vm._e(), (_vm.card.idea_comfortable) ? _c('li', [_vm._v("快適")]) : _vm._e(), (_vm.card.idea_creation) ? _c('li', [_vm._v("創造")]) : _vm._e(), (_vm.card.idea_civility) ? _c('li', [_vm._v("礼節")]) : _vm._e(), (_vm.card.idea_imagination) ? _c('li', [_vm._v("想像")]) : _vm._e(), (_vm.card.idea_sympathy) ? _c('li', [_vm._v("感応")]) : _vm._e(), (_vm.card.idea_expression) ? _c('li', [_vm._v("表現")]) : _vm._e(), (_vm.card.idea_challenge_dream) ? _c('li', [_vm._v("挑夢")]) : _vm._e()])])])]), _c('div', {
    staticClass: "feedback_summary"
  }, [_c('div', {
    staticClass: "feedback_summary_like-wrapper"
  }, [_c('a', {
    staticClass: "like",
    on: {
      "click": function($event) {
        _vm.goEsMycardLikeList()
      }
    }
  }, [_c('p', {
    staticClass: "like--count"
  }, [_c('span', [_vm._v(_vm._s(_vm.card.like))]), _vm._v("いいね")])])])]), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "control--like",
    on: {
      "click": function($event) {
        _vm.sendLike()
      }
    }
  }, [_c('img', {
    staticClass: "like__image",
    attrs: {
      "src": _vm.getLikeImageByState(_vm.isLiked),
      "alt": "いいね"
    }
  }), _c('p', {
    staticClass: "like__name",
    class: {
      '-liked': _vm.isLiked
    }
  })])])] : _vm._e(), (_vm.isDeleteConfirmModal) ? [_c('div', {
    staticClass: "delete_modal"
  }, [_c('div', {
    staticClass: "delete_modal--overlay"
  }), _c('div', {
    staticClass: "delete_modal--main"
  }, [_c('h2', {
    staticClass: "modal-main__title"
  }, [_vm._v("本当に削除しますか？")]), _vm._m(1), _c('div', {
    staticClass: "modal-main__buttons"
  }, [_c('button', {
    staticClass: "modal-main__buttons--normal",
    on: {
      "click": function($event) {
        _vm.isDeleteConfirmModal = false
      }
    }
  }, [_vm._v("キャンセル")]), _c('button', {
    staticClass: "modal-main__buttons--warning",
    on: {
      "click": _vm.deleteCardByTargetId
    }
  }, [_vm._v("削除する")])])])])] : _vm._e(), (_vm.isDeleteCardCompleteModal) ? [_c('div', {
    staticClass: "delete_modal"
  }, [_c('div', {
    staticClass: "delete_modal--overlay"
  }), _c('div', {
    staticClass: "delete_modal--main"
  }, [_c('h2', {
    staticClass: "modal-main__title"
  }, [_vm._v("カードを削除しました")]), _vm._m(2), _c('div', {
    staticClass: "modal-main__buttons"
  }, [_c('button', {
    staticClass: "modal-main__buttons--transition",
    on: {
      "click": function($event) {
        _vm.goEsMycardList()
      }
    }
  }, [_vm._v("みんなのカード一覧へ")])])])])] : _vm._e(), (_vm.isReportProblemModal) ? [_c('div', {
    staticClass: "report-problem_modal"
  }, [_c('div', {
    staticClass: "report-problem_modal--overlay"
  }), _c('div', {
    staticClass: "report-problem_modal--main"
  }, [_c('h2', {
    staticClass: "modal-main__title"
  }, [_vm._v("どんな問題がありましたか？")]), _c('p', {
    staticClass: "modal-main__text"
  }, [_vm._v("問題の内容を教えてください")]), _c('div', {
    staticClass: "modal-main__input_text"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.card.problem_report_reason),
      expression: "card.problem_report_reason"
    }],
    attrs: {
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.card.problem_report_reason)
    },
    on: {
      "change": function($event) {
        _vm.rmEmoji(_vm.card.problem_report_reason)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.card, "problem_report_reason", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "modal-main__buttons"
  }, [_c('button', {
    staticClass: "modal-main__buttons--normal",
    on: {
      "click": function($event) {
        _vm.cancelReportProblem()
      }
    }
  }, [_vm._v("キャンセル")]), _c('button', {
    staticClass: "modal-main__buttons--report",
    class: {
      'disabled': !_vm.card.problem_report_reason
    },
    attrs: {
      "disabled": !_vm.card.problem_report_reason
    },
    on: {
      "click": function($event) {
        _vm.reportProblem()
      }
    }
  }, [_vm._v("報告する")])])])])] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "hamburger-list__item",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('img', {
    staticClass: "hamburger-list__item--image",
    attrs: {
      "src": require("../images/icon_patolamp_blue.png"),
      "alt": "通報"
    }
  }), _c('p', {
    staticClass: "hamburger-list__item--name"
  }, [_vm._v("すでに問題報告済みです")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "modal-main__text"
  }, [_vm._v("復活させることはできません。"), _c('br'), _vm._v("よろしいですか？")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-main__cartoon"
  }, [_c('img', {
    staticClass: "modal-main__cartoon--image",
    attrs: {
      "src": require("../images/img_cat_13.png"),
      "alt": "ねこ"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-62a2e1f8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/es-mycard-detail.pug
// module id = 1404
// module chunks = 1